import API, { API_URL } from '../Api/api';
import { getUserAccessToken } from '../utils/authSession';

const GUEST_ID_KEY = 'pif_guest_id';
const SESSION_ID_KEY = 'pif_visit_session';
const DEBOUNCE_MS = 4000;

let lastTrackKey = '';
let lastTrackAt = 0;

const getGuestId = () => {
  let id = localStorage.getItem(GUEST_ID_KEY);
  if (!id) {
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `guest-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(GUEST_ID_KEY, id);
  }
  return id;
};

const getSessionId = () => {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
};

const shouldSkipPath = (path) =>
  !path
  || path.startsWith('/admin')
  || path.startsWith('/partner');

export const trackPageVisit = async (path) => {
  if (typeof window === 'undefined' || shouldSkipPath(path)) return;

  const trackKey = `${getSessionId()}::${path}`;
  const now = Date.now();
  if (trackKey === lastTrackKey && now - lastTrackAt < DEBOUNCE_MS) return;
  lastTrackKey = trackKey;
  lastTrackAt = now;

  const payload = {
    guest_id: getGuestId(),
    session_id: getSessionId(),
    path,
  };

  const token = getUserAccessToken();
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  try {
    await API.post('/visitors/track', payload, { headers });
  } catch {
    try {
      await fetch(`${API_URL}/visitors/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...headers },
        body: JSON.stringify(payload),
        keepalive: true,
      });
    } catch { /* non-blocking */ }
  }
};
